import SdgsProjectsItems from "../../../components/sdgsProjects/SdgsProjects-items";
import Form from "../../../components/form/Form";
import SdgsProjectContainer from "../../../components/sdgsProjects/SdgsProjects-container";
import PageContainer from "../../../components/page-model/pageItems/Page-container";
import PageItems from "../../../components/page-model/pageItems/Page-items";
import {
  updateSdgsProject,
  getSdgsProjects,
  deleteSdgsProject,
} from "../../../apis/sdgsProjectsApi";
import { useState, useEffect } from "react";
import Error from "../../../components/errors-messages/Error";
import React from "react";

function SdgsProjects(props) {
  const [state, setState] = useState({
    isEditing: false,
    sdgsProjects: [],
    editSdgsProject: null,
    editLoading: false,
    error: null,
  });

  useEffect(() => {
    loadPosts();

    // const socket = openSocket("https://shark-app-2ttko.ondigitalocean.app/website");

    // socket.on("posts", (data) => {
    //   if (data.action === "create") {
    //     addPost(data.post);
    //   } else if (data.action === "update") {
    //     updatePost(data.post);
    //   } else if (data.action === "delete") {
    //     loadPosts();
    //   }
    // });
  }, []);

  const loadPosts = async () => {
    const { data, error } = await getSdgsProjects();
    if ((!data, error)) {
      return setState((prevState) => {
        return {
          isEditing: false,
          sdgsProjects: [],
          editSdgsProject: null,
          editLoading: false,
          error: error,
        };
      });
    }
    setState((prevState) => {
      return { ...prevState, sdgsProjects: data.sdgsProjects };
    });
  };

  const startEditPostHandler = (postId) => {
    setState((prevState) => {
      const loadedSdgsProject = {
        ...prevState.sdgsProjects.find((p) => p._id === postId),
      };
      return {
        ...prevState,
        isEditing: true,
        editSdgsProject: loadedSdgsProject,
      };
    });
  };

  const cancelEditHandler = () => {
    setState((prevState) => {
      return {
        ...prevState,
        isEditing: false,
        editSdgsProject: null,
        error: null,
      };
    });
  };

  const finishEditHandler = async (sdgsProjectData) => {
    setState((prevState) => {
      return { ...prevState, editLoading: true };
    });

    // const formData = new FormData();

    // formData.append("sdgsProjectName", postData.sdgsProjectName);
    // formData.append("content", postData.content);
    // formData.append("image", postData.image);
    let sdgsProjectId = state.editSdgsProject
      ? state.editSdgsProject._id
      : null;
    const { data, error } = await updateSdgsProject(
      props.token,
      sdgsProjectId,
      sdgsProjectData
    );
    if (!data && error) {
      return setState((prevState) => {
        return {
          ...prevState,
          isEditing: false,
          editSdgsProject: null,
          editLoading: false,
          error: error,
        };
      });
    }
    const sdgsProject = {
      _id: data.sdgsProject._id,
      name: data.sdgsProject.name,
      description: data.sdgsProject.description,
    };

    setState((prevState) => {
      let updatedSdgsProjects;
      if (prevState.editSdgsProject) {
        updatedSdgsProjects = prevState.sdgsProjects.map((c) =>
          c._id === sdgsProject._id ? sdgsProject : c
        );
      } else {
        updatedSdgsProjects = prevState.sdgsProjects.concat(sdgsProject);
      }
      return {
        ...prevState,
        sdgsProjects: updatedSdgsProjects,
        isEditing: false,
        editSdgsProject: null,
        editLoading: false,
      };
    });
  };

  const newPostHandler = () => {
    setState((prevState) => {
      return { ...prevState, isEditing: true };
    });
  };

  const deletePostHandler = async (postId) => {
    setState((prevState) => {
      return { ...prevState, postsLoading: true };
    });
    const { data, error } = await deleteSdgsProject(props.token, postId);
    if (!data && error) {
      return setState((prevState) => {
        return {
          ...prevState,
          isEditing: false,
          editSdgsProject: null,
          editLoading: false,
          error: error,
        };
      });
    }
    loadPosts();

    setState((prevState) => {
      return { ...prevState, postsLoading: false };
    });
  };

  return (
    <>
      <Error error={state.error} onHandle={cancelEditHandler} />
      <Form
        editing={state.isEditing}
        currentItem={state.editSdgsProject}
        page={"SdgsProject"}
        // loading={state.editLoading}
        onCancelEdit={cancelEditHandler}
        onFinishEdit={finishEditHandler}
      />
      <PageContainer
        onAddItem={newPostHandler}
        isAuth={props.isAuth}
        title={"SDGs & Project"}
      >
        {state.sdgsProjects.map((sdgsProject) => (
          <PageItems
            onStartEdit={startEditPostHandler.bind(this, sdgsProject._id)}
            key={sdgsProject._id}
            name={sdgsProject.name}
            description={sdgsProject.description}
            onDelete={deletePostHandler.bind(this, sdgsProject._id)}
            isAuth={props.isAuth}
          />
        ))}
      </PageContainer>
      ;
    </>
  );

  // props.isAuth && (
  //   <li className="navigation-item" key="logout">
  //     <button onClick={props.onLogout}>Logout</button>
  //   </li>
  // ),
}

export default SdgsProjects;
